module.exports = __webpack_public_path__ + "img/龙宫.ce287d9b.png";